import { t } from 'i18next';

import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { ProjectAttributes, LoginRequiredError, UserMissmatchError, ProjectLoadingCancelError } from '../actions/ProjectManagerActions';
import { PconLoginStore } from '../stores/PconLoginStore';
import { UIHelper } from './UIHelper';

import utils = egr.wcf.utils;
import { ProjectInstance } from './ProjectInstance';

export abstract class ProjectHelper {
    public static pricesPermitted(): boolean {
        const currentProject: ProjectInstance | null = ProjectManagerStore.getCurrentProject();
        return (
            currentProject == null ||
            ProjectHelper.getProjectUserId(currentProject.attributes) != null
        );
    }

    public static getProjectUserId(projectAttributes?: ProjectAttributes | null): string | null {
        if (projectAttributes != null && !utils.string.isNullOrEmpty(projectAttributes.loginId)) {
            return projectAttributes.loginId;
        }

        return null;
    }

    /**
     * Note: this function should be used for visualisation purpose only (highlight
     * project which may be unloadable). Use `canLoadProject` for the actual
     * check if the project should be loaded!
     */
    public static canSimplyLoadProject(projectAttributes: ProjectAttributes | undefined): boolean {
        const userId: string | null = PconLoginStore.getUserId();
        const projectUserId: string | null = ProjectHelper.getProjectUserId(projectAttributes);

        return userId === projectUserId;
    }

    /**
     * @returns a promise witch resolves with `true` if the current active pCon.login can be used
     * or `flase` if the fallback startup should be used instead
     * Note: it rejects if the current pCon.login user id does not equal the project user id
     */
    public static canLoadProject(projectAttributes?: ProjectAttributes | null): Promise<boolean> {
        const userId: string | null = PconLoginStore.getUserId();
        const projectUserId: string | null = ProjectHelper.getProjectUserId(projectAttributes);

        if (userId !== projectUserId) {
            if (projectUserId != null && projectAttributes != null) {
                if (userId == null) {
                    return Promise.reject<boolean>(new LoginRequiredError(
                        utils.string.isNotNullOrEmpty(projectAttributes.loginName) ?
                        projectAttributes.loginName : projectAttributes.loginEmail || 'unknown'
                    ));
                }
                let currentLogin: string = PconLoginStore.getUserName();
                if (utils.string.isNullOrEmpty(currentLogin)) {
                    currentLogin = PconLoginStore.getUserEmail() || 'unknown';
                }

                return Promise.reject<boolean>(new UserMissmatchError(
                    utils.string.isNotNullOrEmpty(projectAttributes.loginName) ?
                    projectAttributes.loginName : projectAttributes.loginEmail || 'unknown',
                    currentLogin
                ));
            }
            return UIHelper.confirmDialog(
                t('This project has been created without logging in. The demo data without prices is used. How do you want to proceed?'),
                undefined,
                undefined,
                new ProjectLoadingCancelError()
            ).then((): boolean => {
                return false;
            });
        }

        return Promise.resolve(true);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/ProjectHelper.ts